import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const ModalText = styled.div<{ isDanger?: boolean }>(props => ({
    color: props.isDanger ? theme(props).semanticColors.danger.color : "initial",
    marginBottom: `8px`,
}));
